var map = {
	"./admin-shell/admin-shell.module": [
		"./src/app/admin-shell/admin-shell.module.ts",
		"default~admin-shell-admin-shell-module~pages-pages-module",
		"admin-shell-admin-shell-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~admin-shell-admin-shell-module~pages-pages-module",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;